<template>
	<v-dialog
			:value="isDeleteWorkOrder"
			persistent
			width="340"
	>
		<div class="deleteWorkOrder">
			<div class="deleteWorkOrder_header">
				<span>Delete {{ getTextDelete }}</span>
				<button @click="onClose">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="deleteWorkOrder_body">
				Are you sure you want to delete this {{ getTextDelete }}?
			</div>
			<div class="deleteWorkOrder_bottom">
				<button @click="onClose" class="deleteWorkOrder_bottom-btn cancel">Cancel</button>
				<button @click="onDelete" class="deleteWorkOrder_bottom-btn delete">delete</button>
			</div>
		</div>
	</v-dialog>
</template>

<script>
export default {
	name: "DeleteWorkOrder",
	props: {
		isPlanerDayOff: Boolean
	},
	computed: {
		getTextDelete() {
			if (this.isPlanerDayOff) return 'day off';
			return 'work order';
		}
	},
	data: () => ({
		isDeleteWorkOrder: true
	}),
	methods: {
		onClose() {
			this.$emit('updateClose');
		},
		onDelete() {
			this.$emit('updateDelete');
		}
	}
};
</script>

<style scoped lang="scss">

</style>
